import { INVALID_MOVE } from 'boardgame.io/core';
import { debug } from '../../utils/debug';
import type { Ctx } from 'boardgame.io';
import type { BarbadosGameState, SelectActionArgs, BarbadosActionType } from '../../types';
import { validateSelectActionBarbados } from '../validators/selectActionsBarbadosValidator';

/**
 * アクション選択Move（Barbados固有）
 *
 * @param G - Barbadosゲーム状態
 * @param ctx - Boardgame.ioコンテキスト
 * @param args - アクション選択引数
 * @returns void or INVALID_MOVE
 *
 * @see docs/specifications/logic/barbados/phase_03_select_actions_override.md
 */
export function selectActionBarbados(
  { G, ctx }: { G: BarbadosGameState; ctx: Ctx },
  args: SelectActionArgs
): void | typeof INVALID_MOVE {
  // バリデーション
  const validation = validateSelectActionBarbados(G, ctx, args);
  if (!validation.success) {
    console.error(`[selectActionBarbados] Validation failed: ${validation.error} - ${validation.message}`);
    return INVALID_MOVE;
  }

  const player = G.players['0'];
  const action = args.action as BarbadosActionType;

  // アクション選択を記録
  player.selectedAction = action;

  // アクションマーカーを配置
  if (!G.actionMarkers) {
    G.actionMarkers = {
      ENGINEER: false,
      LOCOMOTIVE: false,
      URBANIZATION: false,
      PRODUCTION: false
    };
  }
  G.actionMarkers[action] = true;

  // Locomotiveアクションの即座実行
  // Issue #23: 機関車レベルが最大(6)の場合はレベルを上げない
  if (action === 'LOCOMOTIVE') {
    if (player.locomotiveLevel < 6) {
      player.locomotiveLevel += 1;
      debug.log(`[selectActionBarbados] Player upgraded locomotive to level ${player.locomotiveLevel}`);
    } else {
      debug.log(`[selectActionBarbados] Locomotive already at max level (6), action selected but no upgrade`);
    }
  }

  debug.log(`[selectActionBarbados] Player selected action: ${action}, markers: ${JSON.stringify(G.actionMarkers)}`);
}
